import { createFileRoute, redirect as redirectTo } from '@tanstack/react-router'
import { z } from 'zod'
import { completePostSignin } from '@rpc/post-signin.rpc'
import { AUTH_METHODS } from '@shared/auth-analytics'

const postSigninSearchSchema = z.object({
  redirect: z.string().optional(),
  method: z.enum(AUTH_METHODS).optional(),
})

export const Route = createFileRoute('/auth/post-signin')({
  validateSearch: (search) => postSigninSearchSchema.parse(search),
  loaderDeps: ({ search: { redirect: redirectPath, method: authMethod } }) => ({
    redirectPath,
    authMethod,
  }),
  loader: async ({ deps: { redirectPath, authMethod } }) => {
    throw redirectTo({
      ...(await completePostSignin({
        data: { redirectPath, authMethod },
      })),
    })
  },
  component: PostSigninPage,
  head: () => ({
    meta: [{ title: 'Completing sign-in - Building regs assistant' }],
  }),
})

function PostSigninPage() {
  return null
}
